import {ENV_FEATURES} from 'study_coordinator/env'

/**
 * When set, the webapp is expected to generate random `subjectIdentifier`s when creating new study participants
 * These are expected to be random hex strings between 3-8 characters in length.
 *
 * Typically, this is not set. But in the Pivotal trial, Luminopia needs to be blind to subject treatment and so
 * must be blind to the real subject identifier. To stay blind, the webapp generates random subjectIdentifiers
 * which are not tied to study treatment details but can be used in communication between webapp and the backend to
 * identify a unique subject.
 */
export const generateSubjectIdentifiers = () => ENV_FEATURES.GENERATE_SUBJECT_IDENTIFIERS



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/features.ts